import createClient from "openapi-react-query"

import { env } from "@/env"
import type { paths as iotPaths } from "@/types/api/iot/schema.gen"

import { createApiClient } from "./utils"

const client = createApiClient<iotPaths>({ baseUrl: env.VITE_API2_URL })

// Vanilla API client
export const $iotApiClient = client.vanillaClient

// React-Query client
export const $rqIotApiClient = createClient(client.rqClient)
